import React from 'react';
import UiKitButton from 'components/UiKit/Button';
import './index.css';

const IntegrationButton = (props: React.ComponentProps<typeof UiKitButton>) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <UiKitButton {...props} data-integration-button />
);

export default IntegrationButton;
